import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import FolderIcon from "@material-ui/icons/Folder";

const useStyles = makeStyles((theme) => ({
  root: {},
  docstructicon: {
    "& > svg": {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      fontSize: 32,
    },
  },
}));

const DocumentStructNameReadOnly = ({ document, ...rest }) => {
  const classes = useStyles();

  let icon;
  let name;

  if (document.nodeType === "1") {
    icon = (
      <div className={classes.docstructicon}>
        <SvgIcon>
          <FolderIcon />
        </SvgIcon>
      </div>
    );
    name = (
      <Typography color="textPrimary" variant="body1">
          {document.name}
      </Typography>
    );
  } else {
    icon = (
      <div className={classes.docstructicon}>
        <SvgIcon>
          <FileIcon
            extension={document.fileType}
            {...defaultStyles[document.fileType]}
          />
        </SvgIcon>
      </div>
    );
    name = (
      <Typography color="textPrimary" variant="body1">
          {document.name}
      </Typography>
    );
  }

  return (
    <Box alignItems="center" display="flex" height="2%">
      {icon}
      {name}
    </Box>
  );
};

document.propTypes = {
  className: PropTypes.object,
};

export default DocumentStructNameReadOnly;
